module.exports = __webpack_public_path__ + "img/SideBar.214c8166.png";